import { render, staticRenderFns } from "./CotacaoRemocao.vue?vue&type=template&id=43b9f93e&"
import script from "./CotacaoRemocao.vue?vue&type=script&lang=js&"
export * from "./CotacaoRemocao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports